import type { IconProps } from '@launchpad-ui/icons';
import { Icon } from '@launchpad-ui/icons';

export function LaunchDarklyLogoIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <use href="#app-icon-ld-osmo" />
    </Icon>
  );
}
